import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_EXPORT_STATUS', function (requestStatus) {
    getStore().requestStatus = requestStatus;
});
//# sourceMappingURL=setExportStatus.js.map